import ExchangeManagement from '@/vuepage/exchange/index';
import ExchangeList from '../vuepage/exchange/list';
import ExchangeRules from '../vuepage/exchange/exchangeRules';
import ExchangeDetail from '../vuepage/exchange/detail';

export default [
  {
    path: '/exchange-management',
    component: ExchangeManagement,
    children: [
      {
        path: 'list',
        component: ExchangeList,
        meta: [
          {
            name: '兑换管理',
            url: '/exchange-management',
          },
          {
            name: '兑换列表',
            url: 'list',
          },
        ],
      },
      {
        path: 'exchange-rules',
        component: ExchangeRules,
        meta: [
          {
            name: '兑换管理',
            url: '/exchange-management',
          },
          {
            name: '兑换列表',
            url: 'list',
          },
          {
            name: '兑换规则编辑',
            url: 'exchange-rules',
          },
        ],
      },
      {
        path: 'detail',
        component: ExchangeDetail,
        meta: [
          {
            name: '兑换管理',
            url: '/exchange-management',
          },
          {
            name: '兑换列表',
            url: 'list',
          },
          {
            name: '详情',
            url: 'detail',
          },
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/exchange.js